import { connect } from 'react-redux'
import ReportViewer from './ReportViewer'
import ReportViewerActions from '../../store/report-viewer/actions'

const mapStateToProps = state => ({
  embeddedReportName: state.reportViewerState.embeddedReportName,
  selectedReportRow: state.selectedReportRow.reportRow,
  reportType: state.reports.selectedReportType,
  embeddedReport: state.reportViewerState.embeddedReport
})

const mapDispatchToProps = dispatch => ({
  clearEmbeddedReport: () => {
    dispatch({ type: ReportViewerActions.clear })
  },
  viewedEmbeddedReport: () => {
    dispatch({ type: ReportViewerActions.viewed })
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ReportViewer)



// WEBPACK FOOTER //
// ./src/components/ReportViewer/index.jsx